import { hrApiClient } from '@/lib/api/clients';
import { trackStatistic } from '@/lib/api/common/statistic.api';
import {
  IListResponse,
  IOptionFilterType,
  IOptions,
  IProfessionsQuery,
} from '@/shared';

/** Maps legacy frontend gkeys to HR API `/data/option` gkeys. */
const LEGACY_GKEY_TO_HR: Record<string, IOptionFilterType['gkey']> = {
  address: 'location',
  hrCategory: 'hrmarket_cat',
  proBranch: 'pro_branch',
};

export function resolveHrOptionGkey(gkey: string): IOptionFilterType['gkey'] {
  return LEGACY_GKEY_TO_HR[gkey] ?? (gkey as IOptionFilterType['gkey']);
}

// export async function getPriceList() {
//   const response = await apiClient.get('/options/pricelist');
//   return response.data;
// }

export async function trackCommonStatistic(key: string) {
  await trackStatistic(key);
}

export async function getHrOptions(params: IOptionFilterType) {
  const { data } = await hrApiClient.get<IOptions[]>(`/data/option`, {
    params,
  });
  return data;
}

export async function getOccupations(branchId: number) {
  const { data } = await hrApiClient.get<IOptions[]>(`/data/occupations`, {
    params: { branchId },
  });
  return data;
}

export async function getProfessions(branchId: number) {
  const { data } = await hrApiClient.get<IOptions[]>(`/data/professions`, {
    params: { branchId },
  });
  return data;
}

export async function searchProfessions(
  params: IProfessionsQuery
): Promise<IOptions[]> {
  const { data } = await hrApiClient.get<IListResponse<IOptions> | IOptions[]>(
    '/data/search-professions',
    { params }
  );

  if (Array.isArray(data)) return data;
  return data?.data ?? [];
}
